module.exports = __webpack_public_path__ + "public/images/captcha-circle.f2f1734e26a639a383a74230f2134b84.svg";